/* =========================================================
   MEGA MENU OVERLAY – JS (Prestige safe)
   ========================================================= */

function initMegaMenuOverlay() {
  const openButtons = document.querySelectorAll('.js-open-mega');
  const closeButtons = document.querySelectorAll('.js-close-mega');
  const overlays = document.querySelectorAll('.mega-overlay');

  if (!openButtons.length || !overlays.length) return;

  let megaTopRaf = 0;
  let headerResizeObserver = null;
  let onWindowResize = null;

  function getHeaderSection() {
    return document.querySelector('.shopify-section--header');
  }

  function syncMegaOverlayTop() {
    const header = getHeaderSection();
    if (!header) return;
    const bottom = header.getBoundingClientRect().bottom;
    const px = Math.max(0, Math.round(bottom * 100) / 100);
    document.documentElement.style.setProperty('--mega-overlay-top', `${px}px`);
  }

  function scheduleMegaOverlayTop() {
    if (megaTopRaf) cancelAnimationFrame(megaTopRaf);
    megaTopRaf = requestAnimationFrame(() => {
      megaTopRaf = 0;
      syncMegaOverlayTop();
    });
  }

  function startMegaOverlayTopSync() {
    syncMegaOverlayTop();
    requestAnimationFrame(() => {
      syncMegaOverlayTop();
      requestAnimationFrame(syncMegaOverlayTop);
    });

    const header = getHeaderSection();
    if (header && typeof ResizeObserver !== 'undefined') {
      headerResizeObserver = new ResizeObserver(() => scheduleMegaOverlayTop());
      headerResizeObserver.observe(header);
    }

    onWindowResize = () => scheduleMegaOverlayTop();
    window.addEventListener('resize', onWindowResize, { passive: true });
  }

  function stopMegaOverlayTopSync() {
    if (headerResizeObserver) {
      headerResizeObserver.disconnect();
      headerResizeObserver = null;
    }
    if (onWindowResize) {
      window.removeEventListener('resize', onWindowResize);
      onWindowResize = null;
    }
    if (megaTopRaf) cancelAnimationFrame(megaTopRaf);
    megaTopRaf = 0;
    document.documentElement.style.removeProperty('--mega-overlay-top');
  }

  function setHeaderPopoverLayer(value) {
    document.querySelectorAll('.header x-popover.popover').forEach((el) => {
      if (value) {
        el.style.setProperty('z-index', value);
      } else {
        el.style.removeProperty('z-index');
      }
    });
  }

  function pauseMegaOverlayVideos(root) {
    root.querySelectorAll('video-media[autoplay]').forEach((vm) => {
      if (typeof vm.pause === 'function') vm.pause();
    });
  }

  /** Autoplay in video-media uses inView; nodes inside display:none may start late. Re-trigger after open + more buffer (preload auto in Liquid). */
  function kickMegaOverlayVideos(root) {
    const run = () => {
      root.querySelectorAll('video-media[autoplay]').forEach((vm) => {
        if (typeof vm.play === 'function') vm.play();
      });
    };
    requestAnimationFrame(() => {
      run();
      requestAnimationFrame(run);
    });
  }

  function closeAll() {
    overlays.forEach((overlay) => {
      pauseMegaOverlayVideos(overlay);
      overlay.setAttribute('hidden', true);
    });
    stopMegaOverlayTopSync();
    document.body.classList.remove('mega-open');
    setHeaderPopoverLayer('');
  }

  openButtons.forEach(button => {
    if (button.dataset.megaBound) return;

    button.dataset.megaBound = 'true';

    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const key = button.dataset.mega;
      const overlay = document.querySelector(`#mega-${key}`);

      if (!overlay) return;

      const isOpen = !overlay.hasAttribute('hidden');

      if (isOpen) {
        closeAll();
        return;
      }

      closeAll();
      overlay.removeAttribute('hidden');
      document.body.classList.add('mega-open');
      setHeaderPopoverLayer('100002');
      startMegaOverlayTopSync();
      kickMegaOverlayVideos(overlay);

    });
  });

  closeButtons.forEach(button => {
    if (button.dataset.megaBound) return;

    button.dataset.megaBound = 'true';
    button.addEventListener('click', closeAll);
  });

  overlays.forEach(overlay => {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        closeAll();
      }
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAll();
    }
  });
}

/* Init on DOM ready */
document.addEventListener('DOMContentLoaded', initMegaMenuOverlay);

/* Re-init when Shopify re-renders sections */
document.addEventListener('shopify:section:load', initMegaMenuOverlay);
document.addEventListener('shopify:section:select', initMegaMenuOverlay);
